import { OneDataCollection } from '@factorialco/factorial-one-react/dist/experimental'
import { ContributorsDataCollectionDocument } from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

const ContributorsDataCollection = () => {
  const { navigation } = useNavigation()

  const source = useGraphqlDataSource({
    document: ContributorsDataCollectionDocument,
    mapData: (data) => data.projectManagement.projectContributorsConnection.nodes,
    mapVariables: ({ search, sortings }) => ({
      employeeName: search,
      sortOrder: sortings?.[0],
    }),
    mapPagination: (data) => ({
      total: data.projectManagement.projectContributorsConnection.totalCount ?? 0,
    }),
    itemUrl: (item) => {
      if (item.employee?.id) {
        return navigation.projects.contributors.contributorId.fullPath({
          employeeId: item.employee.id,
        })
      }
      return undefined
    },
    search: {
      enabled: true,
    },
    sortings: {
      fullName: {
        label: i18n.t('project_management.table.contributors_list.headers.full_name'),
      },
    },
    defaultSorting: {
      field: 'fullName',
      order: 'asc',
    },
  })

  return (
    <OneDataCollection
      source={source}
      visualizations={[
        {
          type: 'table',
          options: {
            columns: [
              {
                label: i18n.t('project_management.table.contributors_list.headers.full_name'),
                render: (item) => ({
                  type: 'person',
                  value: {
                    firstName: item.employee?.fullName ?? '',
                    lastName: '',
                    src: buildUrl(item.employee?.access?.avatar),
                  },
                }),
                sorting: 'fullName',
              },
              {
                label: i18n.t('project_management.table.contributors_list.headers.job_title'),
                render: (item) => ({
                  type: 'text',
                  value: item.employee?.referenceContract?.jobTitle ?? '-',
                }),
              },
              {
                label: i18n.t(
                  'project_management.table.contributors_list.headers.projects_assigned'
                ),
                render: (item) => ({
                  type: 'text',
                  value: item.projectWorkersConnection.totalCount?.toString(),
                }),
              },
            ],
          },
        },
      ]}
    />
  )
}

export default ContributorsDataCollection
